import { Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NgForm } from '@angular/forms';
import moment from 'moment';
// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
// services
import { AppStateService } from '../../../shared/services/app-state.service';
import { DataStorageService } from '../../../shared/services/data-storage.service';
import { ErrorHandler } from '../../../shared/services/error-handler.service';
import { AppLoaderService } from '../../../shared/services/app-loader.service';
// globals
import { ABC_PARTNERS } from '../../../shared/globals';
// models
import { AppState } from '../../models/app-state.interface';
import { FlightFinderQuote } from '../../../shared/models/flight-finder.interface';

declare var ga: any;
declare var exponea: any;

@Component({
  selector: 'app-get-flyback-details',
  templateUrl: './get-flyback-details.component.html',
  styleUrls: ['./get-flyback-details.component.scss'],
  providers: [AppStateService, ErrorHandler]
})
export class GetFlybackDetailsComponent implements OnInit, OnDestroy {
  @Input()
  flightDirection: number;

  @Input()
  copyLoaded: Boolean = false;

  @Input()
  appCopy;

  @Input()
  appAirportCopy;

  @Input()
  flightData;

  @Input()
  languageCode = '';

  @Input()
  selectedLanguage = '';

  @Input()
  bookingReference = '';

  private _routeParamsSubscription: Subscription;
  private _bookingRefreshed: Subscription;
  private _userLanguageSubscription: Subscription;
  private _loadingSubscription: Subscription;
  private _currentBooking;

  private _bookingCarrier;
  private _flightNumber;
  private _destinationCountry: string = null;

  public isReturnDateValid = true;
  public bookingDetails;
  public bookingProduct;
  public dataBookingLoaded: Boolean = false;

  public dateInput: string = null; // YYYY-MM-DD string from app-datepicker
  public dateError: String = 'Please enter a valid date';

  public state: AppState;

  public flightProducts;
  public partnerName: string = null;
  public isD2dService: boolean;
  public flightCodeNumber: any;

  public calendarLabelText = 'Pick a date';
  public calendarMinDate = moment().format('YYYY-MM-DD');
  public calendarMaxDate = moment().add(12, 'months').format('YYYY-MM-DD');
  public isLoading = false;

  constructor(
    private _appStore: Store<AppState>,
    private _appStateService: AppStateService,
    private _errorService: ErrorHandler,
    private _dataStorageService: DataStorageService,
    private _http: HttpClient,
    private _appLoaderService: AppLoaderService,
    private _router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit(): void {
    this.setViewValues();
  }

  setViewValues() {
    this.state = this.getState(this._appStore);

    this.setBookingStoreData(this.state);
    this.setFlightStoreData(this.state);

    this._appStore.dispatch({ type: 'UPDATE_BOOKING_PAID', payload: true });
    if (this.bookingReference !== null) {
      this._appStore.dispatch({ type: 'UPDATE_BOOKING_REFERENCE', payload: this.bookingReference });
    }

    this._dataStorageService.saveData();
  }

  setBookingStoreData(s: AppState) {
    this.dataBookingLoaded = true;

    this.bookingDetails = this.getBookingReducer(s).bookingDetails;
    this.flightDirection = this.bookingDetails.journeyLegDetails[0].journeyDirection;
    this._bookingCarrier = this.bookingDetails.carrier.airlineCode;
    this.bookingProduct = this.bookingDetails.bookingProduct;
    this.calendarMinDate = s.flybackReducer.flybackMinDate ? s.flybackReducer.flybackMinDate : s.flightReducer.flightDetails.flightResponse?.flightInfo?.requestedDateTime;
    const minDate = moment(this.calendarMinDate).subtract(1, 'days');
    this.calendarMaxDate = moment(minDate).add(1, 'years').add(1, 'months').format('YYYY-MM-DD');
    const maxDate = moment(this.calendarMaxDate).add(1, 'days');
    // this.myOptions.disableUntil = {
    //   year: minDate.year(),
    //   month: minDate.month() + 1,
    //   day: minDate.date()
    // };

    // this.myOptions.disableSince = {
    //   year: maxDate.year(),
    //   month: maxDate.month() + 1,
    //   day: maxDate.date()
    // };

    if (s.flybackReducer.flybackFlightDate) {
      this.dateInput = moment(s.flybackReducer.flybackFlightDate).format('YYYY-MM-DD');
    } else {
      this.dateInput = moment(minDate).add(1, 'days').format('YYYY-MM-DD');
    }
    if (!s.flybackReducer.flybackMinDate) {
      this._appStore.dispatch({ type: 'UPDATE_FLYBACK_MIN_DATE', payload: s.flightReducer.flightDetails.flightResponse?.flightInfo?.requestedDateTime });
    }
  }

  setFlightStoreData(s: AppState) {
    this.flightData = s.flightReducer.flightDetails.flightResponse;
    this._flightNumber = this.flightData.flightStatusDetails[0].airlineCode + this.flightData.flightStatusDetails[0].flightNumber;
    this.flightProducts = s.flightReducer.flightDetails.flightProducts;
    this._destinationCountry = s.flightReducer.flightDetails.flightFinalDestination.airportCountryName;

    if (this.bookingProduct === 'abc' || this.isD2dService) {
      this.partnerName = ABC_PARTNERS.find(partner => partner.code === this.flightData.flightStatusDetails[0].airlineCode).codeName;
    }

    const departureDate = moment(this.flightData.flightStatusDetails[0].departureDateTimeDetails.scheduledDate).format('DD-MM-YYYY');
    this.flightCodeNumber = this.flightData.flightStatusDetails[0].airlineCode;

    if (this.flightCodeNumber === 'BA') {
      this.flightCodeNumber = 1
    } else if (this.flightCodeNumber === 'EZY') {
      this.flightCodeNumber = 2
    } else if (this.flightCodeNumber === 'VS') {
      this.flightCodeNumber = 3
    } else if (this.flightCodeNumber === 'AA') {
      this.flightCodeNumber = 4
    } else if (this.flightCodeNumber === 'QF') {
      this.flightCodeNumber = 5
    } else if (this.flightCodeNumber === 'CX') {
      this.flightCodeNumber = 6
    } else if (this.flightCodeNumber === 'AY') {
      this.flightCodeNumber = 7
    }
  }

  getCurrentBookingReducer(s: AppState) {
    const d2dReducer = s.oldBookingInfoReducer.d2dReducer;
    const bookingProduct = d2dReducer.currentBookingProduct;
    return bookingProduct === "abc" ? d2dReducer.outboundBooking.currentBookingReducer : d2dReducer.inboundBooking.currentBookingReducer;
  }

  getBookingReducer(s: AppState) {
    const d2dReducer = s.oldBookingInfoReducer.d2dReducer;
    const bookingProduct = d2dReducer.currentBookingProduct;
    return bookingProduct === "abc" ? d2dReducer.outboundBooking.bookingReducer : d2dReducer.inboundBooking.bookingReducer;
  }

  getFlightFinderReducer(s: AppState) {
    const d2dReducer = s.oldBookingInfoReducer.d2dReducer;
    const bookingProduct = d2dReducer.currentBookingProduct;
    return bookingProduct === "abc" ? d2dReducer.outboundBooking.flightFinderReducer : d2dReducer.inboundBooking.flightFinderReducer;
  }

  async handleFormSubmit(form: NgForm, value, e) {
    e.preventDefault();
    this.markFormGroupTouched(form);

    if (!this.validateDate(this.dateInput)) {
      return;
    }
    this._appLoaderService.showLoader();

    const d = moment(this.dateInput, 'YYYY-MM-DD').set({
      hour: 0,
      minute: 0,
      second: 0,
      millisecond: 0
    });

    const state = this.getState(this._appStore);

    // already flyback, selected booking is in teh reducer;
    const dataSaved = sessionStorage.getItem('OLD_DATA_SAVED');
    const outboundAdditionBagPrice = state.flightFinderReducer.outboundAdditionBagPrice;
    const inboundAdditionBagPrice = state.flightFinderReducer.inboundAdditionBagPrice;

    if (!dataSaved) {

      sessionStorage.setItem('OLD_DATA_SAVED', '1');

      const abcBooking = this.getState(this._appStore).d2dReducer.outboundBooking;
      const ccdBooking = this.getState(this._appStore).d2dReducer.inboundBooking;

      this._appStore.dispatch({ type: 'SAVE_OLD_BOOKINGS_DATA', payload: { abcBooking: abcBooking, ccdBooking: ccdBooking } });
    }

    const formattedDateItem = d.format('YYYY-MM-DDTHH:mm:ss');
    // check if it gets null on back click
    let quoteFlightRequest = state.flybackReducer?.quoteFlightRequest?.airline ? state.flybackReducer.quoteFlightRequest : state.flightFinderReducer.quoteFlightRequest;

    if (!quoteFlightRequest?.airline && state.flightFinderReducer.sessionUsed) {

      const length = state.flightReducer.flightDetails.flightResponse.flightStatusDetails.length;
      const departure = state.flightReducer.flightDetails.flightResponse.flightStatusDetails[0];
      const arrival = state.flightReducer.flightDetails.flightResponse.flightStatusDetails[length - 1];
      const bookingJourney = state.currentBookingReducer.currentBooking.bookingJourney[0];

      let bookingJourneyBagitems = {
        bags: 2,
        childEquipment: 0,
        oversizeItem: 0,
      };

      const keyMap = {
        Bags: 'bags',
        ChildEquipment: 'childEquipment',
        OversizeItem: 'oversizeItem',
      }

      bookingJourney.virtualBagClassification.forEach((item) => {
        bookingJourneyBagitems[keyMap[item.Type]] = item.Count;
      });

      quoteFlightRequest = {
        ...quoteFlightRequest,
        departureAirport: departure.departureAirport.airportCode,
        fromAirport: departure.departureAirport.airportName,
        fromCity: departure.departureAirport.airportCityName,
        departDate: departure.departureDateTimeDetails.scheduledDate,

        arrivalAirport: arrival.arrivalAirport.airportCode,
        toAirport: arrival.arrivalAirport.airportName,
        toCity: arrival.arrivalAirport.airportCityName,

        airline: departure.airlineCode,
        airlineName: departure.airlineName,

        bagCount: bookingJourney.virtualBagCount,
        bagItems: bookingJourneyBagitems
      }

    }

    const flyBackquoteFlightRequest: FlightFinderQuote = JSON.parse(JSON.stringify(quoteFlightRequest));

    const promoFromUrl = state.flybackReducer.promoFromUrl ? state.flybackReducer.promoFromUrl : state.flightFinderReducer.promoFromUrl;
    const csMotoFromUrl = state.flybackReducer.csMotoFromUrl ? state.flybackReducer.csMotoFromUrl : state.flightFinderReducer.csMotoFromUrl;

    if (!state.flybackReducer?.quoteFlightRequest?.airline) {
      flyBackquoteFlightRequest.fromAirport = quoteFlightRequest.toAirport;
      flyBackquoteFlightRequest.fromCity = quoteFlightRequest.toCity;
      flyBackquoteFlightRequest.toAirport = quoteFlightRequest.arrivalAirport;
      flyBackquoteFlightRequest.toCity = quoteFlightRequest.fromCity;
      flyBackquoteFlightRequest.departureAirport = quoteFlightRequest.arrivalAirport;
      flyBackquoteFlightRequest.arrivalAirport = quoteFlightRequest.departureAirport;
    }
    flyBackquoteFlightRequest.departDate = d.format('YYYY-MM-DD');

    // reset every thing
    // this._appStateService.resetCurrentBookingData();
    // this._appStateService.resetPanelNumber();
    this._appStateService.resetFlightFinderData();
    // this._appStateService.resetTimeslotData();
    // this._appStateService.resetHubDropReducer();
    // this._appStateService.resetMilesData();
    // this._appStateService.resetPriceData();
    // this._appStateService.resetUpsellbookingReducer();

    // update required reducers
    this._appStore.dispatch({ type: 'UPDATE_FLYBACK_PROMO_FROM_URL', payload: promoFromUrl });
    this._appStore.dispatch({ type: 'UPDATE_FLYBACK_CS_MOTO_FROM_URL', payload: csMotoFromUrl });

    this._appStore.dispatch({ type: 'UPDATE_PROMO_FROM_URL', payload: promoFromUrl });
    this._appStore.dispatch({ type: 'UPDATE_CS_MOTO_FROM_URL', payload: csMotoFromUrl });

    this._appStore.dispatch({ type: 'FLY_BACK_FLIGHT_DATE', payload: formattedDateItem });
    this._appStore.dispatch({ type: 'UPDATE_FLYBACK_BOOKING_STATUS', payload: true });
    this._appStore.dispatch({ type: 'UPDATE_FLIGHT_QUOTE', payload: flyBackquoteFlightRequest });

    this._appStore.dispatch({ type: 'UPDATE_PAGINATION_DATA', payload: null });
    this._appStore.dispatch({ type: 'UPDATE_FLIGHT_QUOTE_CACHE_REQUEST', payload: null });
    this._appStore.dispatch({ type: 'UPDATE_FLIGHT_QUOTE_DATA', payload: flyBackquoteFlightRequest });
    this._appStore.dispatch({ type: 'INCREMENT_REQUEST_COUNT' });

    this._appStore.dispatch({ type: 'SAVE_OUTBOUND_ADDITIONAL_BAG_PRICE', payload: outboundAdditionBagPrice });
    this._appStore.dispatch({ type: 'SAVE_INBOUND_ADDITIONAL_BAG_PRICE', payload: inboundAdditionBagPrice });

    const mapServices = { departure: 'abc', arrival: 'ccd', door_to_door: 'd2d' }
    this._appStore.dispatch({ type: 'SESSION_SERVICE_TYPE', payload: mapServices['arrival'] });
    this._appStore.dispatch({ type: 'UPDATE_CURRENT_STEP' });

    exponea.track('flyback_date', { date: formattedDateItem, entry_source: this.getState(this._appStore).d2dReducer.entrySource || 'direct', });

    this._dataStorageService.saveDataPromise().then(() => {
      this._router.navigate(['complete'], { queryParams: { ref: this.bookingReference } });
    });

  }

  private markFormGroupTouched(form) {
    Object.keys(form.controls).forEach(field => {
      const control = form.controls[field];
      control.markAsTouched({ onlySelf: true });
    });
  }

  /** Called by app-datepicker's (dateChange) output — receives YYYY-MM-DD string */
  onDateChanged(dateStr: string) {
    this.dateInput = dateStr;
    this.validateDate(dateStr);
  }

  validateDate(dateStr: string): boolean {
    if (!dateStr) {
      this.isReturnDateValid = false;
      return false;
    }
    const inputDate = moment(dateStr, 'YYYY-MM-DD');
    const minDate = moment(this.calendarMinDate, 'YYYY-MM-DD');
    const maxDate = moment(this.calendarMaxDate, 'YYYY-MM-DD');

    this.isReturnDateValid = inputDate.isBetween(minDate, maxDate, 'days', '[]');
    return this.isReturnDateValid;
  }

  abortFlyback() {
    exponea.track('no_flight_booked', { entry_source: this.getState(this._appStore).d2dReducer.entrySource || 'direct', });
    this._appStore.dispatch({ type: 'UPDATE_FLYBACK_BOOKING_STATUS', payload: false });
    this._router.navigate(['complete'], { queryParams: { ref: this.bookingReference } });
  }

  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
      .subscribe(s => state = s);
    return state;
  }

  ngOnDestroy(): void {
    if (this._routeParamsSubscription) { this._routeParamsSubscription.unsubscribe(); }
    if (this._bookingRefreshed) { this._bookingRefreshed.unsubscribe(); }
    if (this._userLanguageSubscription) { this._userLanguageSubscription.unsubscribe(); }
    if (this._loadingSubscription) { this._loadingSubscription.unsubscribe(); }
    this._currentBooking = null;
  }
}
